import { syncWishlistToggleButtons } from '../snippets/wishlist.js';
import { getWishlist } from '../utils/wishlist.js';

const SECTION_ID = 'ird-card-product-ajax';
const CARD_VIEW = 'card';

const getShopifyRoot = () => {
  const root = window.routes?.root_url ?? window.Shopify?.routes?.root ?? '/';
  return root.endsWith('/') ? root : `${root}/`;
};

const extractCardHtml = (html) => {
  if (!html?.trim()) return '';

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const card = doc.querySelector('.ird-card-product');

  return card ? card.outerHTML : html.trim();
};

export default class WishlistPage {
  constructor() {
    this.root = document.querySelector('[js-wishlist]');
    if (!this.root) return;

    this.emptyEl = this.root.querySelector('[js-wishlist-empty]');
    this.listEl = this.root.querySelector('[js-wishlist-list]');

    this.render();
    document.addEventListener('ird:wishlist:updated', () => this.render());
  }

  async fetchProductCard(handle) {
    const root = getShopifyRoot();
    const encodedHandle = encodeURIComponent(handle);

    const viewUrl = `${root}products/${encodedHandle}?view=${CARD_VIEW}`;
    const viewResponse = await fetch(viewUrl, {
      credentials: 'same-origin',
    });

    if (viewResponse.ok) {
      const html = await viewResponse.text();
      const cardHtml = extractCardHtml(html);
      if (cardHtml) return cardHtml;
    }

    const sectionsUrl = `${root}products/${encodedHandle}?sections=${SECTION_ID}`;
    const sectionsResponse = await fetch(sectionsUrl, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });

    if (!sectionsResponse.ok) return '';

    const data = await sectionsResponse.json();
    return extractCardHtml(data[SECTION_ID] || '');
  }

  setPending() {
    this.root.classList.remove('is-ready');
    this.root.dataset.wishlistState = 'pending';
    this.root.setAttribute('hidden', '');
  }

  reveal(state) {
    this.root.dataset.wishlistState = state;
    this.root.removeAttribute('hidden');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.root.classList.add('is-ready');
      });
    });
  }

  showEmpty() {
    this.listEl.innerHTML = '';
    this.reveal('empty');
  }

  showList() {
    this.reveal('list');
  }

  async render() {
    this.setPending();

    const handles = getWishlist();

    if (!handles.length) {
      this.showEmpty();
      return;
    }

    this.listEl.innerHTML = '';

    try {
      const cards = await Promise.all(
        handles.map(async (handle) => {
          const html = await this.fetchProductCard(handle);
          if (!html) return null;

          const item = document.createElement('li');
          item.className = 'ird-wishlist__item';
          item.innerHTML = html;
          return item;
        })
      );

      cards.filter(Boolean).forEach((item) => {
        this.listEl.appendChild(item);
      });

      syncWishlistToggleButtons(this.listEl);

      if (!this.listEl.children.length) {
        this.showEmpty();
      } else {
        this.showList();
      }
    } catch {
      this.showEmpty();
    }
  }
}
